export default __webpack_public_path__ + "static/media/servicosp3.e67ad9dd.jpg";